import { Controller } from "@hotwired/stimulus"
import "./ibkr_connection_form_component.css"

export default class extends Controller {
  static targets = ["token", "queryId", "result", "testButton"]
  static values = { portfolio: String }

  connect() {
    const token = this.tokenTarget.value.trim()
    const queryId = this.queryIdTarget.value.trim()

    if (token && queryId) this.test()
  }

  test() {
    const token = this.tokenTarget.value.trim()
    const queryId = this.queryIdTarget.value.trim()

    if (!token || !queryId) {
      this.showResult("error", "Please fill in both fields.")
      return
    }

    this.testButtonTarget.disabled = true
    this.testButtonTarget.innerHTML =
      '<i class="fas fa-spinner fa-spin"></i> Testing...'
    this.resultTarget.hidden = true

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch("/portfolios/test_ibkr_connection", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ token, query_id: queryId, portfolio_id: this.portfolioValue })
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          this.showResult(
            "success",
            "Connection successful! Your Flex Query is configured correctly. Click 'Save' to complete the integration."
          )
        } else if (data.error && data.error.includes("not yet ready")) {
          this.showResult(
            "warning",
            "Credentials are valid! The report is still generating. Try again in a minute to also verify your Flex Query fields."
          )
        } else {
          this.showResult("error", data.error)
        }
      })
      .catch(() => {
        this.showResult("error", "Network error. Please try again.")
      })
      .finally(() => {
        this.testButtonTarget.disabled = false
        this.testButtonTarget.innerHTML =
          '<i class="fas fa-plug"></i> Test Connection'
      })
  }

  showResult(type, message) {
    const el = this.resultTarget
    el.hidden = false

    const styles = {
      success: {
        cls: "alert alert-success mt-2 mb-0 py-2 px-3",
        icon: "fa-check-circle"
      },
      warning: {
        cls: "alert alert-warning mt-2 mb-0 py-2 px-3",
        icon: "fa-info-circle"
      },
      error: {
        cls: "alert alert-danger mt-2 mb-0 py-2 px-3",
        icon: "fa-exclamation-circle"
      }
    }
    const { cls, icon } = styles[type] || styles.error

    el.className = cls
    el.innerHTML = `<i class="fas ${icon}"></i> ${message}`
  }
}
